import { InboundPartnr, Material, SurfaceTreatment, Assignment, UnitValue, MaterialColor, MaterialDimension } from "../types/CommonTypes";
import { ConditionType } from "../hooks/usePartNrAssignment";
import { mergeFirstNonEmpty, isEmpty } from "../utils/merge";
import QueryParams from "../utils/QueryParams";

export function buildAssignment(
    partNrs: InboundPartnr[],
    material?: Material,
    surfaceTreatment?: SurfaceTreatment,
    condition?: MaterialColor | MaterialDimension | null,
    conditionType?: ConditionType | null,
    devMode = QueryParams.devMode
): Assignment {
    const mergedRows = mergeFirstNonEmpty(partNrs, isEmpty);
    let payload: any = {
        bmId: material?.id || null,
        stMaterialId: surfaceTreatment?.stId || null,
        stThickness: surfaceTreatment?.thickness || null,
        stCoverage: mergedRows.coverage || null,
        stDensity: surfaceTreatment?.density || null,
        bmDensity: material?.density || null,
        bmName: material?.name || null,
        stName: surfaceTreatment?.stName || null
    };
    if(devMode){
        payload = {
            bmId: payload?.id || mergedRows.bmId || null,
            stMaterialId: payload?.stId || mergedRows.stMaterialId || null,
            stThickness: payload?.thickness || mergedRows.thickness || null,
            stCoverage: mergedRows.coverage || null,
            stDensity: payload?.stDensity || mergedRows.stDensity || null,
            bmDensity: payload?.bmDensity || mergedRows.bmDensity || null,
            bmName: payload?.bmName || mergedRows.bmName || null,
            stName: payload?.stName || mergedRows.stName || null
        };
    }

    const toUnitValue = (val: any, unit: string): UnitValue | null => {
        if (val === null || val === undefined) return null;
        return { value: `${val}`, unit } as UnitValue;
    };

    const assignment: Assignment = {
        bmId: payload.bmId || null,
        stMaterialId: payload.stMaterialId || null,
        stThickness: toUnitValue(payload.stThickness, "micrometer"),
        stCoverage: toUnitValue(payload.stCoverage, "decimal"),
        stDensity: toUnitValue(payload.stDensity, "kg/dm³"),
        bmDensity: toUnitValue(payload.bmDensity, "kg/dm³"),
        bmName: payload.bmName || '',
        stName: payload.stName || '',
        conditionType: conditionType ?? null,
        condition: condition ?? null,
    };

    return assignment;
}

export function buildMultipleAssignments(
    partNrs: InboundPartnr[],
    material?: Material,
    surfaceTreatment?: SurfaceTreatment,
    condition?: MaterialColor | MaterialDimension | null,
    conditionType?: ConditionType | null,
    devMode = QueryParams.devMode
): Assignment[] {

    let assignments: Assignment[] = [];

    let payload: any = {
        bmId: material?.id || null,
        stMaterialId: surfaceTreatment?.stId || null,
        stThickness: surfaceTreatment?.thickness || null,
        stDensity: surfaceTreatment?.density || null,
        bmDensity: material?.density || null,
        bmName: material?.name || null,
        stName: surfaceTreatment?.stName || null
    };
    const toUnitValue = (val: any, unit: string): UnitValue | null => {
        if (val === null || val === undefined) return null;
        return { value: `${val}`, unit } as UnitValue;
    };

    for(let p of partNrs){
        payload.stCoverage = p.coverage || null;
        const assignment: Assignment = {
            partNr: p.partnr,
            bmId: payload.bmId || null,
            stMaterialId: payload.stMaterialId || null,
            stThickness: toUnitValue(payload.stThickness, "micrometer"),
            stCoverage: toUnitValue(payload.stCoverage, "decimal"),
            stDensity: toUnitValue(payload.stDensity, "kg/dm³"),
            bmDensity: toUnitValue(payload.bmDensity, "kg/dm³"),
            bmName: payload.bmName || '',
            stName: payload.stName || '',
            conditionType: conditionType ?? null,
            condition: condition ?? null,
        };
        assignments.push(assignment);
    }
    return assignments;
}

export default buildAssignment;
